const Login = () => import('@/account/login/login.vue');
const Register = () => import('@/account/register/register.vue');
// const Activate = () => import('@/account/activate/activate.vue');
// const ResetPasswordInit = () => import('@/account/reset-password/init/reset-password-init.vue');
// const ResetPasswordFinish = () => import('@/account/reset-password/finish/reset-password-finish.vue');
const MakerThon = () => import('@/entities/makeAThon/MakeAThon.vue');
const IntroduceMobile = () => import('@/entities/introduce/IntroduceMobile.vue');

export default [
  {
    path: '/guide',
    name: 'Guide',
    component: MakerThon,
    meta: {
      hideNavBar: true,
    },
  },
  {
    path: '/mobile-down',
    name: 'IntroduceMobile',
    component: IntroduceMobile,
    meta: {
      hideNavBar: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      hideForAuth: true,
      hideNavBar: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      hideForAuth: true,
      hideNavBar: true,
    },
  },
  // {
  //   path: '/account/activate',
  //   name: 'Activate',
  //   component: Activate,
  // },
  // {
  //   path: '/account/reset/request',
  //   name: 'ResetPasswordInit',
  //   component: ResetPasswordInit,
  // },
  // {
  //   path: '/account/reset/finish',
  //   name: 'ResetPasswordFinish',
  //   component: ResetPasswordFinish,
  // },
];
